import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RenderIf from '../../render-if/components/render-if';

import '../styles/modal-header.css';

class ModalHeader extends Component {
  render() {
    const { customClass, title, icon, subtitle, onClick, hideCloseBtn } = this.props;
    const { t } = this.context;

    return (
      <div className={`modal-header-container ${customClass ? customClass : ''}`}>
        <div className="modal-header-container__header">
          <RenderIf if={icon}>
            <img src={icon} alt="modal icon" className="modal-header-container__header__icon" />
          </RenderIf>
          <RenderIf if={title}>
            <p className="modal-header-container__header__title">{t(title || '')}</p>
          </RenderIf>
          {!hideCloseBtn && <span className="glyphicon glyphicon-remove pull-right modal-header-container__header__close" onClick={onClick} />}
        </div>
        <RenderIf if={subtitle}>
          <p className="modal-header-container__subtitle">{t(subtitle || '')}</p>
        </RenderIf>
      </div>
    );
  }
}

ModalHeader.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  lang: state.i18nState.lang,
}))(ModalHeader);



// WEBPACK FOOTER //
// ./src/app/shared/modal-header/components/modal-header.js